import React from 'react';
import { BookingResource } from '../../lib/bookings';

interface BookingResourceListProps {
  resources: BookingResource[];
  onRemoveResource?: (resourceId: string) => Promise<void>;
  onAddResource?: () => void;
  selectedResourceIds?: Set<string>;
}

export default function BookingResourceList({
  resources,
  onRemoveResource,
  onAddResource,
  selectedResourceIds = new Set()
}: BookingResourceListProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <h3 className="text-sm font-medium text-gray-900">Resources</h3>
          <span className="text-xs text-gray-500">
            ({resources.length})
          </span>
        </div>
        {onAddResource && (
          <button
            onClick={() => onAddResource()}
            className="inline-flex items-center px-2.5 py-1.5 text-xs font-medium text-gray-700 bg-gray-50 border border-gray-300 rounded-md hover:bg-gray-100"
          >
            Add Resource
          </button>
        )}
      </div>
      <div className="divide-y divide-gray-200">
        {resources.map((resource) => (
          <div key={resource.id} className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="h-10 w-10 rounded-full bg-black flex items-center justify-center text-sm font-medium text-white overflow-hidden">
                  {resource.resource?.avatar_url ? (
                    <img 
                      src={resource.resource.avatar_url} 
                      alt={`${resource.resource?.first_name} ${resource.resource?.last_name}`}
                      className="h-full w-full object-cover"
                    />
                  ) : (
                    <>{resource.resource?.first_name[0]}{resource.resource?.last_name[0]}</>
                  )}
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-900">
                    {resource.resource?.first_name} {resource.resource?.last_name}
                  </div>
                  <div className="text-sm text-gray-500">
                    {resource.resource?.email}
                  </div>
                  <div className="text-xs font-medium text-gray-700 mt-1">
                    {resource.role.charAt(0).toUpperCase() + resource.role.slice(1)}
                  </div>
                </div>
              </div>
              {onRemoveResource && (
                <button
                  onClick={() => onRemoveResource(resource.resource_id)}
                  className="text-xs text-red-600 hover:text-red-800"
                >
                  Remove
                </button>
              )}
            </div>
          </div>
        ))}
        {resources.length === 0 && (
          <div className="p-8 text-center">
            <p className="text-sm text-gray-500">No resources assigned</p>
            {onAddResource && (
              <button
                onClick={onAddResource}
                className="mt-4 inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md"
              >
                Add Resource
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}